import { checkAuthStatus } from '../../../../helpers/api';
import type { TAction } from '../../models';

export const checkStatus: TAction = async ({ form: { change } }) => {
    try {
        await checkAuthStatus();

        change('isAuthorized', true);
    } catch (error) {
        change('isAuthorized', false);
    }
};
